import { ChevronDown, ChevronUp } from "lucide-react";

interface WorkpaperFocusControlsProps {
  /** True when the full page header is expanded (slim bar hidden). */
  headerExpanded: boolean;
  /** Expand/collapse the full page header. */
  onToggleHeader: () => void;
  /** Leave focus mode — back to the full workpaper table. */
  onExit: () => void;
}

const buttonClasses =
  "flex flex-shrink-0 items-center border border-stone-200 text-sm font-medium text-stone-600 transition-colors hover:bg-stone-100 hover:text-stone-900";

/**
 * The focus-mode corner controls: header expand/collapse chevron +
 * "Back to Workpaper" exit. Rendered at the top-left in both focus-mode
 * states — on the slim identity bar when collapsed, and above the full
 * header when expanded — so the controls never move when toggling.
 */
export const WorkpaperFocusControls = ({
  headerExpanded,
  onToggleHeader,
  onExit,
}: WorkpaperFocusControlsProps) => {
  return (
    <div className="flex flex-shrink-0 items-center gap-2">
      <button
        type="button"
        onClick={onToggleHeader}
        aria-expanded={headerExpanded}
        title={headerExpanded ? "Hide the page header" : "Show the page header"}
        className={`${buttonClasses} px-1.5 py-1`}
      >
        {headerExpanded ? (
          <ChevronUp className="h-4 w-4" aria-hidden="true" />
        ) : (
          <ChevronDown className="h-4 w-4" aria-hidden="true" />
        )}
      </button>
      <button
        type="button"
        onClick={onExit}
        title="Back to workpaper (Esc)"
        className={`${buttonClasses} px-2.5 py-1`}
      >
        Back to Workpaper
      </button>
    </div>
  );
};
